import { render, staticRenderFns } from "./YevmiyeNumarasi.vue?vue&type=template&id=10facd0f"
import script from "./YevmiyeNumarasi.vue?vue&type=script&lang=ts"
export * from "./YevmiyeNumarasi.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports